
import { defineComponent, PropType } from 'vue'
import { UserAvatar, ProposalUserDto } from '@bd/components'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'CounterProposalListItem',
  components: { UserAvatar },
  props: {
    participant: {
      type: Object as PropType<ProposalUserDto>,
      required: true,
    },
    userType: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n()
    return { t }
  },
})
